module.exports = __webpack_public_path__ + "static/img/icon-lab-white.08e256d2.svg";